<template>
  <el-row class="banner-row">
    <el-col>
      <div class="banner-row-2" style="margin: auto;width: 1180px;">
        <div class="banner-left">
          <div class="banner-box">
            <div class="left-image">
              <img
                class="bannerlogo"
                src="@/assets/bannerlogo.png"
              />
              <img
                class="image-title"
                src="@/assets/slogin.png"
              />
            </div>
            <div class="left-but">
              <div class="android-but" @click="downloadFile('Android')">
                <img class="but-logo"
                  src="@/assets/alogo.png"
                />
                <img class="but-logo-hover"
                  src="@/assets/alogo-2.png"
                />
                <div class="but-desc">
                  <label>Android</label>
                  <label>客户端</label>
                </div>
              </div>
              <div class="ios-but" @click="downloadFile('IOS')">
                <img class="but-logo"
                  src="@/assets/plogo.png"
                />
                <img class="but-logo-hover"
                  src="@/assets/plogo-2.png"
                />
                <div class="but-desc">
                  <label>IOS & iPadOS</label>
                  <label>客户端</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="banner-right">
          <img
            class="right-image"
            src="@/assets/banneriphone.png"
          />
        </div>
      </div>
    </el-col>
  </el-row>
  <el-row>
    <el-col style="margin: auto;">
      <div class="content">
        <div class="title-h1">丰富商品，满足您的一切需求</div>
        <div class="title-desc">柚优品汇集全球精选商品，从日常用品到奢侈品，应有尽有，让您一站式购齐</div>
        <div class="card-box">
          <div class="card">
            <!-- <div class="info"></div> -->
            <div class="bg"></div>
          </div>
          <div class="card">
            <div class="bg"></div>
          </div>
          <div class="card">
            <div class="bg"></div>
          </div>
          <div class="card">
            <div class="bg"></div>
          </div>
        </div>
        <div class="title-h1">100%正品保障，放心购物</div>
        <div class="title-desc">我们承诺所有商品均为正品，严格把控供应链，让您买得安心，用得放心</div>
        <div class="title-carousel">
          <div class="left">
            <div class="row1">
              <div class="title2">
                <img
                  class="title2-image"
                  src="@/assets/leaf.png"
                />
                <div>品牌直供</div>
              </div>
              <div class="title2-desc">
                与全球知名品牌建立直接合作关系，所有商品均由品牌方或授权经销商提供，从源头上确保正品。
              </div>
            </div>
            <div class="row1">
              <div class="title2">
                <img
                  class="title2-image"
                  src="@/assets/leaf.png"
                />
                <div>严格质检</div>
              </div>
              <div class="title2-desc">
                每件商品入库前均经过专业质检团队严格检查，确保商品质量符合标准，杜绝假冒伪劣产品。
              </div>
            </div>
            <div class="row1">
              <div class="title2">
                <img
                  class="title2-image"
                  src="@/assets/leaf.png"
                />
                <div>七天无理由退换</div>
              </div>
              <div class="title2-desc">
                购买后7天内，如对商品不满意，在不影响二次销售的情况下，可申请无理由退换货，让您购物无忧。
              </div>
            </div>
            <div class="attention">*注：部分商品不支持七天无理由退换货请知悉</div>
          </div>
          <div class="right">
            <el-carousel indicator-position="none" height="469px">
              <el-carousel-item>
                <img
                  class="carousel-image"
                  src="@/assets/ad-1.png"
                />
              </el-carousel-item>
              <el-carousel-item>
                <img
                  class="carousel-image"
                  src="@/assets/ad-2.png"
                />
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
        
        <div class="title-h1">用户的真实评价</div>
        <div class="title-desc">来自柚优品用户的真实体验分享，看看他们怎么说</div>
        <div class="evaluate">
          <div class="card">
            <div class="info">
              <img
                class="bg-image"
                src="@/assets/copy.png"
              />
              <img
                class="bg-image2"
                src="@/assets/copy2.png"
              />

              <img
                class="star-image"
                src="@/assets/star.png"
              />
              <div class="star-title">在柚优品买过好几次化妆品了，和专柜买的一样，价格更优惠。物流非常快，客服态度很好，推荐购买！</div>
              <div class="star-user">
                <img
                  class="user-image"
                  src="@/assets/mswang.png"
                />
                <div class="user-info">
                  <label>王女士</label>
                  <label>美妆爱好者</label>
                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="info">
              <img
                class="bg-image"
                src="@/assets/copy.png"
              />
              <img
                class="bg-image2"
                src="@/assets/copy2.png"
              />

              <img
                class="star-image"
                src="@/assets/star.png"
              />
              <div class="star-title">作为一个数码控，我很在意产品的真伪。在柚优品买的手机验过了是正品，价格比官网便宜，还有赠品，满意！</div>
              <div class="star-user">
                <img
                  class="user-image"
                  src="@/assets/mrli.png"
                />
                <div class="user-info">
                  <label>李先生</label>
                  <label>资深数码控</label>
                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="info">
              <img
                class="bg-image"
                src="@/assets/copy.png"
              />
              <img
                class="bg-image2"
                src="@/assets/copy2.png"
              />

              <img
                class="star-image"
                src="@/assets/star.png"
              />
              <div class="star-title">作为时尚博主，我对服饰品质要求很高柚优品的设计师品牌服饰款式新颖，和我在时装周看到的同款，性价比超高！</div>
              <div class="star-user">
                <img
                  class="user-image"
                  src="@/assets/mscchen.png"
                />
                <div class="user-info">
                  <label>陈女士</label>
                  <label>时尚达人</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-col>
    <el-col style="background-color: #2B2B2B; margin: 112px 0 0 0;">
      <div class="bottom">
        <div>
          <div class="but">
            <img @click="downloadFile('Android')"
              class="down-image"
              src="@/assets/android.png"
            />
            <img @click="downloadFile('IOS')"
              class="down-image"
              src="@/assets/ios.png"
            />
          </div>
        </div>
        <div>
          <img
            class="bottom-image"
            src="@/assets/bottomiphone.png"
          />
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>

export default {
  name: 'HomeView',

  methods: {
    downloadFile(type) {
      if(type === 'IOS') {
        const userAgent = navigator.userAgent;
        // 判断是否为iOS设备
        if (/iphone|ipad|ipod/.test(userAgent.toLowerCase())) {
            // 跳转到iOS App Store
            window.location.replace(`itms-apps://apps.apple.com/cn/app/id6755280707`);
            return;
        }
        window.location.href='https://itunes.apple.com/app/id6755280707?mt=8'
      } else {
        window.location.href='https://tcdn.youyoupin.com/20251117/2z0KdI4lW34raLHHASjh6F/20251117_164055.apk'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.banner-row {
  // background-color: #F2DDC5;
  background: radial-gradient(circle, #F1DBC2 0%, #F5F2ED 100%);
  // padding-bottom: 88px;
  .banner-row-2 {
    background-image: url(@/assets/banenrbg.png);
    background-position: center; /* 居中背景图 */
    background-repeat: no-repeat; /* 不重复背景图 */
    background-size: cover; /* 覆盖整个元素，保持图片比例不变 */
    display: flex;
    justify-content: space-around;
    .banner-left ,.banner-right {
      margin: 56px 0 0;
    }
    .banner-left {
      padding: 35px 0 0;
      display: flex;
      // flex-flow: row-reverse;
      
      .banner-box {
        display: inline-block;
      }
      .image-title {
        margin: 35px 0 27px;
        // max-width: 319px;
        width: 319px;
      }
      .bannerlogo {
        max-width: 181px;
        width: 100%;
        display: block;
        margin: auto;
      }

      .left-but {
        display: flex;
        justify-content: center;
        flex-flow: row;
        .android-but ,.ios-but {
          font-size: 16px;
          display: flex;
          flex-flow: row;
          // padding: 10px 0px 10px 22px;
          background-color: #fff;
          border-radius: 68px;
          height: 68px;
          width: 200px;
          align-items: center;
          padding: 0 0 0 20px;
          color: #552600;
          img {
            margin-right: 18px;
          }
          .but-logo-hover {
            display: none;
          }
          .but-logo {
            display: block;
          }
        }
        .android-but:hover ,.ios-but:hover {
          border: 1px solid #A77952;
          background-color: rgba(242,223,207,0.55);
          box-shadow: 0px 0px 15px 3px rgba(242,223,207,0.55);
          
          .but-logo-hover {
            display: block;
          }
          .but-logo {
            display: none;
          }
        }
        .ios-but img {
          width: 42px;
          height: 50px;
        }
        .android-but {
          margin: 0 21px 0 0;
          img {
            width: 40px;
            height: 46px;
          }
        }
        .but-desc {
          display: flex;
          flex-flow: column;
          justify-content: center;
          text-align: left;
        }
      }
    }
    .right-image {
      width: 451px;
      animation: floatAnimation 5s infinite;
    }
  }
}

.content {
  padding: 69px 0 0 0;
  font-family: PingFang SC;
  text-align: center;
  .title-h1 {
    color: #552600;
    font-weight: 500;
    font-size: 32px;
  }
  .title-desc {
    color: #ABA49F;
    font-size: 22px;
  }
  .card-box {
    margin: 40px auto 70px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    justify-content: center;
    .card {
      background-position: center; /* 居中背景图 */
      background-repeat: no-repeat; /* 不重复背景图 */
      background-size: cover; /* 覆盖整个元素，保持图片比例不变 */
      overflow: hidden;
      width: 288px;
      height: 376px;
      position: relative;
      margin-right: 5px;
      .bg {
        position: absolute;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 3;
        top: 376px;
        -webkit-transition: all .3s;
        transition: all .3s;
        background-position: center; /* 居中背景图 */
        background-repeat: no-repeat; /* 不重复背景图 */
        background-size: cover; /* 覆盖整个元素，保持图片比例不变 */
      }
    }
    :hover .bg {
      top: 0;
    }
    :nth-child(1) {
      background-image: url(@/assets/ad1.png);
      .bg {
        background-image: url(@/assets/ad1-2.png);
      }
    }
    :nth-child(2) {
      background-image: url(@/assets/ad2.png);
      .bg {
        background-image: url(@/assets/ad2-2.png);
      }
    }
    :nth-child(3) {
      background-image: url(@/assets/ad3.png);
      .bg {
        background-image: url(@/assets/ad3-2.png);
      }
    }
    :nth-child(4) {
      background-image: url(@/assets/ad4.png);
      margin-right: 0px;
      .bg {
        background-image: url(@/assets/ad4-2.png);
      }
    }
  }
  .title-carousel {
    margin: 40px 0 80px 0;
    display: flex;
    flex-flow: row;
    justify-content: center;
    .left {
      width: 608px;
      margin: 0 38px 0 0;
      .title2 {
        display: flex;
        justify-items: center;
        align-items: center;
        font-weight: 500;
        font-size: 26px;
        color: #552600;
        margin: 26px 0 12px;
        .title2-image {
          width: 32px;
          height: 27px;
          margin-right: 8px;
        }
      }
      .title2-desc {
        font-size: 16px;
        color: #3E3E3E;
        text-align: left;
      }
      .attention {
        font-size: 16px;
        color: #CA9772;
        text-align: left;
        margin-top: 27px;
      }
    }
    .right {
      width: 506px;
      .carousel-image {
        width: 506px;
      }
    }
  }

  .evaluate {
    margin: 40px 0 0 0;
    display: flex;
    justify-content: center;
      height: 346px;
    .card {
      width: 376px;
      height: 342px;
      box-shadow: 0px 0px 10px 1px rgba(218, 215, 213, 0.55);
      margin: 0 24px 0 0;
      .info {
        position: relative;
        padding: 31px 23px 0;
        .bg-image {
          position: absolute;
          top: 32px;
          left: 23px;
          width: 44px;
        }
        .bg-image2 {
          position: absolute;
          top: 172px;
          right: 35px;
          width: 44px;
          // z-index: -1;
        }
        .star-image {
          z-index: 1;
          width: 153px;
          position: relative;
        }
        .star-title {
          font-size: 18px;
          color: #444444;
          text-align: left;
          margin: 26px 0 0 0;
          position: relative;
          z-index: 1;
        }
        .star-user {
          display: flex;
          margin: 22px 0 0 0;
          img.user-image {
            width: 66px;
            margin: 0 20px 0 0;
          }
          .user-info {
            display: flex;
            flex-flow: column;
            justify-content: center;
            text-align: left;
            font-size: 18px;
            :nth-child(2) {
              color: #ABA49F;
            }
          }
        }
      }
    }
    .card:hover {
      background-color: #FFFBF7;
      border: 2px solid #F1D4C0;
    }
  } 
}

.bottom {
  width: 1180px;
  margin: auto;
  justify-content: space-between;
  display: flex;
  padding: 0 80px 15px 10px;
  box-sizing: border-box;
  .but {
    display: flex;
    flex-flow: column;
    justify-content: center;
    height: 100%;
    // padding: 0 0 0 80px;
    .down-image {
      width: 200px;
    }
    :nth-child(1) {
      margin-bottom: 42px;
    }
  }
  .bottom-image {
    width: 480px;
    margin-top: -23px;
  }
}


@keyframes floatAnimation {
    0% {
        -webkit-transform: translateY(0);
        transform: translateY(0)
    }

    50% {
        -webkit-transform: translateY(30px);
        transform: translateY(30px)
    }

    to {
        -webkit-transform: translateY(0);
        transform: translateY(0)
    }
}

</style>
